import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Images } from '../../config/images';

const PortfolioOverviewSection = ({ hasPortfolioData, loading, timelineLabels, selectedTimeline, onSelectTimeline }) => {
  if (hasPortfolioData) {
    return (
      <div className='container-fluid text-center graph'>
        <p className='fz-18 fw-600 mb-28 text-left'>Portfolio Performance</p>
        <div className='timeline'>
          {React.Children.toArray(
            timelineLabels.map((label) => {
              return (
                <button
                  type='button'
                  onClick={() => {
                    onSelectTimeline(label);
                  }}
                  className={`timeline__item ${label === selectedTimeline ? 'active' : ''}`}
                >
                  {label}
                </button>
              );
            })
          )}
        </div>
      </div>
    );
  }

  if (!loading) {
    return (
      <>
        <div className='container-fluid'>
          <hr className='hr my-56' />
        </div>
        <div className='zero-state text-center'>
          <div>
            <img src={Images.portfoliozero} alt='' className='mb-32' />
          </div>
          <p className='fw-700 fz-20 mb-16'>Start potentially building your wealth. One brick at a time.</p>
          <p className='mb-40'>
            Once you invest in a series on the Realbricks marketplace, you will see the series assets associated with your shares.
          </p>
          <Link to='/' className='px-47 py-10 bg-copper text-white fw-600 radius-4 fz-16 btn-link'>
            Browse properties
          </Link>
        </div>
      </>
    );
  }

  return <></>;
};

PortfolioOverviewSection.propTypes = {
  hasPortfolioData: PropTypes.bool,
  loading: PropTypes.bool,
  timelineLabels: PropTypes.array,
  selectedTimeline: PropTypes.string,
  onSelectTimeline: PropTypes.func,
};

export default PortfolioOverviewSection;
